import { useContext, useEffect } from 'react';
import { useNavigate } from "react-router";
import AuthContext from '../AuthContextComponent/AuthContext';
import AuthenticationService from "../../Services/AuthenticationService";

/**
 * Rendered wherever the app would previously have shown a tenant picker
 * (SelectTenant/SelectTenantPopup). In a single-partner system there is
 * never a legitimate choice to make, so any state where the frontend
 * thinks it's logged in but has no tenant is treated as stale -- this
 * logs out and returns to a clean login screen instead.
 */
function ForceLogout() {
    const authCtx = useContext(AuthContext);
    let navigate = useNavigate();

    useEffect(() => {
        authCtx.logout();
        AuthenticationService.logout()
            .then(() => { })
            .catch(() => { });
        navigate("/login", { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}

export default ForceLogout;
